import { render, staticRenderFns } from "./menuMesaAyuda.vue?vue&type=template&id=001a7d8e&scoped=true"
import script from "./menuMesaAyuda.vue?vue&type=script&lang=js"
export * from "./menuMesaAyuda.vue?vue&type=script&lang=js"
import style0 from "./menuMesaAyuda.vue?vue&type=style&index=0&id=001a7d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a7d8e",
  null
  
)

export default component.exports